const resources = [
  {
    icon: "ri-camera-2-line",
    title: "Passport Photo Locations in Coeur d'Alene",
    items: [
      { label: "Walgreens — Sherman Ave, Coeur d'Alene", href: "https://www.walgreens.com/photo" },
      { label: "CVS Pharmacy — Coeur d'Alene location", href: "https://www.cvs.com/photo" },
      { label: "FedEx Office Print & Ship — N 4th St", href: "https://www.office.fedex.com/" },
      { label: "Walmart Photo Center — Coeur d'Alene", href: "https://www.walmart.com/photo" },
    ],
  },
  {
    icon: "ri-id-card-line",
    title: "Idaho Driver's License / ID",
    items: [
      { label: "ITD Driver's Services — 1505 Seltice Way, CDA", href: "https://itd.idaho.gov/dmv/" },
      { label: "Kootenai County DMV services info", href: "https://www.kcgov.us/191/Motor-Vehicles" },
      { label: "Post Falls ITD location — nearby option", href: "https://itd.idaho.gov/dmv/" },
      { label: "Idaho.gov — online renewal options", href: "https://www.idaho.gov/" },
    ],
  },
  {
    icon: "ri-plane-line",
    title: "Spokane International Airport (GEG)",
    items: [
      { label: "Airport — 9000 W Airport Dr, Spokane WA (30 mi west)", href: "https://spokaneairports.net/" },
      { label: "Nonstop service to Seattle, LA, Denver, Phoenix", href: "https://spokaneairports.net/" },
      { label: "TSA PreCheck & Global Entry enrollment on-site", href: "https://spokaneairports.net/" },
      { label: "spokaneairports.net for schedules and parking", href: "https://spokaneairports.net/" },
    ],
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Coeur d&apos;Alene Passport Applicants
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything you need to complete your passport application in the Coeur d&apos;Alene area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {resources.map((r, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${r.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">{r.title}</h3>
              <ul className="space-y-2">
                {r.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm">
                    <i className="ri-check-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#1A365D] hover:underline transition-colors">
                      {item.label} <i className="ri-external-link-line text-xs ml-1"></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}